import React from 'react';


export type BgisSearchDetailProps = {
  children?: React.ReactNode;
};

export const BgisSearchDetailBody : React.FC<BgisSearchDetailProps> = ({children}) => {
  
  return (<ul className='bgis-search-details-body'>{children}</ul>);

};